import React, { useState } from "react"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faVideo, faVideoSlash} from "@fortawesome/free-solid-svg-icons";
import SOCKET from "../const/socketNames";

const CameraButton = ({peerInstance, socket, roomId}) => {
    const [mute, setMute] = useState(true)

    const disabledCamera = () => {
        peerInstance.toggleCamera(mute)
        socket?.emit(SOCKET.MEETING_CAMERA_STATE, {roomId, cameraOn: mute})
        setMute(!mute)
    }

    return (
        <div id="stopVideo" className={`options__button ${!mute && "background__red"}`} onClick={disabledCamera}>
            {
                mute ? 
                    <img src="/Iconcamera.png"/>
                    :
                    <img src="/IconcameraMute.png"/>
            }
        </div>
       
    )
}

export default CameraButton